(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-story-accordion"] && !Shopify.designMode) return;
  try {
    
  const initializeHomeStoryAccordions = (root = document) => {
    root.querySelectorAll('.home-story-accordion').forEach((section) => {
      if (section.dataset.accordionReady === 'true') return;

      const items = Array.from(section.querySelectorAll('.home-story-accordion__item'));
      const visualVideo = section.querySelector('[data-story-visual-video]');

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const desktopVisual = window.matchMedia('(min-width: 1200px)');

      const syncVisualPlayback = () => {
        if (!visualVideo) return;
        const shouldPlay = desktopVisual.matches && !reducedMotion && section.classList.contains('is-accordion-open') && document.visibilityState === 'visible';
        visualVideo.defaultPlaybackRate = 1;
        visualVideo.playbackRate = 1;
        if (shouldPlay && visualVideo.readyState >= 2) {
          visualVideo.play().catch(() => {});
        } else {
          visualVideo.pause();
        }
      };

      const updateVisualSource = () => {
        if (!visualVideo) return;
        const source = visualVideo.dataset.src;
        if (desktopVisual.matches && source && !visualVideo.getAttribute('src')) {
          visualVideo.setAttribute('src', source);
          visualVideo.load();
        } else if (!desktopVisual.matches && visualVideo.getAttribute('src')) {
          visualVideo.pause();
          visualVideo.removeAttribute('src');
          visualVideo.load();
        }
        syncVisualPlayback();
      };

      const updateOpenState = () => {
        const hasOpenItem = items.some((item) => item.open);
        section.classList.toggle('is-accordion-open', hasOpenItem);
        syncVisualPlayback();
      };

      const stopItemAnimations = (item) => {
        if (item.homeStoryHeightAnimation) {
          item.homeStoryHeightAnimation.onfinish = null;
          item.homeStoryHeightAnimation.cancel();
          item.homeStoryHeightAnimation = undefined;
        }
        if (item.homeStoryPanelAnimation) {
          item.homeStoryPanelAnimation.cancel();
          item.homeStoryPanelAnimation = undefined;
        }
      };

      const animateItem = (item, shouldOpen) => {
        const summary = item.querySelector('.home-story-accordion__summary');
        const panel = item.querySelector('.home-story-accordion__panel');
        if (!summary || !panel) return;

        const startHeight = item.getBoundingClientRect().height;
        stopItemAnimations(item);
        item.style.removeProperty('height');
        item.style.removeProperty('overflow');

        if (shouldOpen) item.open = true;

        item.dataset.accordionTarget = shouldOpen ? 'open' : 'closed';

        if (reducedMotion || typeof item.animate !== 'function') {
          item.open = shouldOpen;
          delete item.dataset.accordionTarget;
          window.requestAnimationFrame(updateOpenState);
          return;
        }

        const endHeight = shouldOpen ? item.getBoundingClientRect().height : summary.getBoundingClientRect().height;
        const duration = shouldOpen ? 560 : 440;
        item.dataset.accordionMotion = shouldOpen ? 'opening' : 'closing';
        item.style.overflow = 'hidden';

        const heightAnimation = item.animate([
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ], {
          duration,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'both'
        });

        const panelAnimation = panel.animate(shouldOpen ? [
          { opacity: 0, transform: 'translateY(-10px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ] : [
          { opacity: 1, transform: 'translateY(0)' },
          { opacity: 0, transform: 'translateY(-8px)' }
        ], {
          duration: shouldOpen ? 420 : 300,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'both'
        });

        item.homeStoryHeightAnimation = heightAnimation;
        item.homeStoryPanelAnimation = panelAnimation;

        heightAnimation.onfinish = () => {
          if (item.homeStoryHeightAnimation !== heightAnimation) return;
          if (!shouldOpen) item.open = false;
          heightAnimation.onfinish = null;
          heightAnimation.cancel();
          panelAnimation.cancel();
          item.style.removeProperty('height');
          item.style.removeProperty('overflow');
          delete item.dataset.accordionMotion;
          delete item.dataset.accordionTarget;
          item.homeStoryHeightAnimation = undefined;
          item.homeStoryPanelAnimation = undefined;
          window.requestAnimationFrame(updateOpenState);
        };
      };

      items.forEach((item) => {
        const summary = item.querySelector('.home-story-accordion__summary');
        const handleSummaryClick = (event) => {
          event.preventDefault();
          const isOpening = item.dataset.accordionTarget ? item.dataset.accordionTarget !== 'open' : !item.open;

          if (isOpening) {
            items.forEach((otherItem) => {
              if (otherItem !== item && (otherItem.open || otherItem.dataset.accordionTarget === 'open')) {
                animateItem(otherItem, false);
              }
            });
          }

          animateItem(item, isOpening);
        };
        const handleToggle = () => {
          window.requestAnimationFrame(updateOpenState);
        };

        if (summary) summary.addEventListener('click', handleSummaryClick);
        item.addEventListener('toggle', handleToggle);
        item.homeStorySummary = summary;
        item.homeStorySummaryHandler = handleSummaryClick;
        item.homeStoryToggleHandler = handleToggle;
      });

      const isThemeEditor = window.Shopify && window.Shopify.designMode;
      const shouldRevealOnScroll = section.classList.contains('home-story-accordion--scroll-reveal') && !reducedMotion && !isThemeEditor && 'IntersectionObserver' in window;

      if (shouldRevealOnScroll) {
        const revealSection = () => {
          section.classList.add('is-scroll-active');
          if (section.homeStoryObserver) {
            section.homeStoryObserver.disconnect();
            delete section.homeStoryObserver;
          }
        };

        const sectionRect = section.getBoundingClientRect();
        section.classList.add('is-scroll-ready');
        if (sectionRect.top <= window.innerHeight * 0.58 && sectionRect.bottom >= window.innerHeight * 0.28) {
          revealSection();
        } else {
          section.homeStoryObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) revealSection();
            });
          }, {
            rootMargin: '-28% 0px -42% 0px',
            threshold: 0
          });
          section.homeStoryObserver.observe(section);
        }
      }

      if (visualVideo) {
        updateVisualSource();
        visualVideo.addEventListener('canplay', syncVisualPlayback);
        desktopVisual.addEventListener('change', updateVisualSource);
        document.addEventListener('visibilitychange', syncVisualPlayback);
      }

      updateOpenState();

      section.homeStoryCleanup = () => {
        if (section.homeStoryObserver) {
          section.homeStoryObserver.disconnect();
          delete section.homeStoryObserver;
        }
        if (visualVideo) visualVideo.removeEventListener('canplay', syncVisualPlayback);
        desktopVisual.removeEventListener('change', updateVisualSource);
        document.removeEventListener('visibilitychange', syncVisualPlayback);
        items.forEach((item) => {
          stopItemAnimations(item);
          if (item.homeStorySummary && item.homeStorySummaryHandler) {
            item.homeStorySummary.removeEventListener('click', item.homeStorySummaryHandler);
          }
          if (item.homeStoryToggleHandler) item.removeEventListener('toggle', item.homeStoryToggleHandler);
        });
      };

      section.dataset.accordionReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHomeStoryAccordions());
  } else {
    initializeHomeStoryAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeHomeStoryAccordions(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.home-story-accordion').forEach((section) => {
      if (section.homeStoryObserver) section.homeStoryObserver.disconnect();
      if (section.homeStoryCleanup) section.homeStoryCleanup();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
